class Document {
  id = null

  name = ''

  original_name = ''

  event_id = null

  created_at = null

  updated_at = null

  link = ''

  // Documents are public by default (once uploaded).
  private = false

  constructor(options = {}) {
    Object.assign(this, options)
  }

  // let document = (new Document).fill({ name: "whatever" });
  fill(options) {
    return Object.assign(this, options)
  }

  getIcon() {
    switch (this.name.split('.').pop()) {
      case 'pdf':
        return 'fa-file-pdf'

      case 'xlsx':
        return 'fa-file-excel'

      case 'xls':
        return 'fa-file-excel'

      case 'docx':
        return 'fa-file-word'

      case 'doc':
        return 'fa-file-word'

      case 'pptx':
        return 'fa-file-powerpoint'

      case 'ppt':
        return 'fa-file-powerpoint'

      case 'png':
        return 'fa-file-image'

      case 'jpg':
        return 'fa-file-image'

      case 'jpeg':
        return 'fa-file-image'

      default:
        return 'fa-file'
    }
  }

  getIconClass() {
    switch (this.getIcon()) {
      case 'fa-file-pdf':
        return 'red white--text'

      case 'fa-file-excel':
        return 'green white--text'

      case 'fa-file-word':
        return 'blue white--text'

      case 'fa-file-image':
        return 'orange white--text'

      default:
        return 'grey white--text'
    }
  }

  setPrivate() {
    this.private = true
  }

  isPrivate() {
    return this.private
  }

  setPublic() {
    this.private = false
  }

  isPublic() {
    return !this.private
  }
}

export default Document
